import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useGetEntryRecordResult from 'client/hooks/useGetEntryRecordResult';

const useExtraUploadCheck = () => {
    const { isLogin } = useSelector(s => s.userLoginState);
    const { enableExtraUploadFeature } = useSelector(s => s.settingPromo);
    const { getEntryRecordResult } = useGetEntryRecordResult();
    const [checkResult, setCheckResult] = useState(false);

    useEffect(() => {
        // 如果沒有開啟額外上傳功能，直接設為 true
        if (!enableExtraUploadFeature) {
            setCheckResult(true);
            return;
        }
        if (!isLogin) {
            setCheckResult(false);
            return;
        }
        getEntryRecordResult()
            .then(({ isAIFlowFinished, isUploadFlowFinished, data }) => {
                // 邏輯 1: 如果 data 的 length === 0 就 return false
                if (!data || data.length === 0) {
                    setCheckResult(false);
                    return;
                }

                // 邏輯 2: 如果 data length > 0，確認 isAIFlowFinished 和 isUploadFlowFinished 都要是 true
                const isCompleted = isAIFlowFinished && isUploadFlowFinished;
                setCheckResult(isCompleted);
            })
            .catch(console.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enableExtraUploadFeature, isLogin]);

    return checkResult;
};

export default useExtraUploadCheck;
